import React from 'react';
import '../css/Overview&History.css';

const OverviewHistory = () => {
        return (
                <div className="overview-history">
                        <h2>Overview And History</h2>
                        <p>
                                We are happy to note your interest in joining a professional career in the hospitality industry. The Institute was established as Food Craft Institute in the year 2019. It was setup by the Department of Tourism, Govt. of Rajasthan and affiliated with the National Council for Hotel Management & Catering Technology, Noida, an apex body under the Ministry of Tourism, Govt. of India. It is situated in the heart of Sumperpur, having 8 Acre of sprawling campus, indoor & outdoor sports facilities.

                                The Institute provides an adequate training facilities and other inputs to the students to help them to gain professional expertise. We look forward to a mutually beneficial association. We offer One & Half year Diploma in Food Production, Food & Beverage Service & Front Office operation. All these courses are designed to cater the needs of professionals in Hotel Industry, Airline Catering, Cruise and Railway Catering, Industrial Catering, Institutional and Hospital Catering.
                        </p>
                </div>
        );
};

export default OverviewHistory;